<script lang="ts" setup>
import Round from '~/components/gamescreen/Round.vue'

const { $ts: t } = useNuxtApp()

const { tournament } = defineProps<{
  tournament: Tournament
}>()

useSeoMeta({
  title: `${t('Brackets')} | ${tournament.name} @ ${tournament.event_name}`,
})

defineOgImageComponent('DartsSpace', {
  title: `${t('Brackets')} | ${tournament.name}`,
})
</script>

<template>
  <div
    v-if="tournament.phase !== 'elimination' && !tournament.complete"
  >
    <UiAlert
      variant="warning"
      :title="$t('Elimination phase has not started')"
    />
  </div>
  <div
    v-else
    class="flex flex-col gap-2"
  >
    <Round
      group="b"
      :boards="[]"
      :display-only="true"
      :tournament="tournament"
    />
  </div>
</template>
